module.exports = __webpack_public_path__ + "images/柏纳长图_11.jpg?v=f74e1b5c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_11.jpg
 ** module id = 155
 ** module chunks = 1 2
 **/